import React, {useEffect} from 'react'
import classes from "./style.module.scss"
import useStyles from 'isomorphic-style-loader/useStyles'
import { useIntl } from 'react-intl'

const NotificationTabs = props => {
    useStyles(classes)
    const {showType, setShowType, notificationNoRead} = props
    const Intl = useIntl()

    const navs = [
        {
            id: 0,
            title: Intl.formatMessage({id: 'activities'}),
            type: 'activity',
        },
        {
            id: 1,
            title: Intl.formatMessage({id: 'promo'}),
            type: 'promo',
        },
        {
            id: 2,
            title: Intl.formatMessage({id: 'others'}),
            type: 'others',
        },
    ]

    return (
        <div className={classes.NotificationTabs}>
            <ul>
                {
                    navs?.map((item, index) => {
                        return (
                            <li key={item?.type+index}>
                                <div className={`${classes.TabItem} ${showType == item?.type ? classes.Selected: ''} `} onClick={() => setShowType(item?.type)}>
                                    <span className={`${notificationNoRead?.[item?.type] > 0 ? classes.NoRead: ''}`}>
                                        {item?.title}
                                    </span>
                                </div>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    )
}

export default NotificationTabs